/* Read hostUrl from meta tag — must load before plugins.bundle.js and scripts.bundle.js */
var hostUrl = (function () {
    var meta = document.querySelector('meta[name="host-url"]');
    return meta ? meta.getAttribute('content') : '';
}());
